import React from 'react'
import ConsumerRankingView from './ConsumerRankingView/ConsumerRankingView'
import { useConsumption } from '../../../hooks'
import { useFilter } from '../../../../filter/hook'

export default function ConsumerRankingPresenter() {
  const {bigConsumersRankingQuery:{ data, isLoading, isError}} = useConsumption()

  const {setFilter, filter} = useFilter()
  const onClickConsumer = (point: any) => {
    setFilter({...filter, device_name: point.Values.device_name})
  }
  if (isLoading) {
    return <>...</>
  }

  if (isError) {
    return <>Error</>
  }
  return (
    <ConsumerRankingView list={data?.data || undefined} onClickConsumer={onClickConsumer} />
  )
}
